module.exports = __webpack_public_path__ + "static/media/SWEEPY-SWY-3500.15d45ffa.jpg";